import { styled } from '@mui/system'

export const DataTableSection = styled('section')(() => ({
  width: '100%',
  '& .MuiDataGrid-row': {
    cursor: 'pointer',
  },
}))
